import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/cskh")({
  component: () => <Outlet />,
});
